export const getPosRegisterStorageKey = (branchId) => `pos_cash_register_${branchId}`;
export const getPosSessionStorageKey = (branchId) => `pos_cash_session_${branchId}`;
export const getPosRegisterlessStorageKey = (branchId) => `pos_registerless_${branchId}`;
export const POS_MOBILE_MEDIA_QUERY = '(max-width: 767px)';
export const REGISTERLESS_POST_SUBMIT_DESTINATION_NEW_SALE = 'newSale';
export const REGISTERLESS_POST_SUBMIT_DESTINATION_RECEIPT = 'receipt';
export const DEFAULT_REGISTERLESS_POST_SUBMIT_DESTINATION = {
  mobile: REGISTERLESS_POST_SUBMIT_DESTINATION_NEW_SALE,
  desktop: REGISTERLESS_POST_SUBMIT_DESTINATION_RECEIPT,
};

const REGISTERLESS_POST_SUBMIT_DESTINATIONS = new Set([
  REGISTERLESS_POST_SUBMIT_DESTINATION_NEW_SALE,
  REGISTERLESS_POST_SUBMIT_DESTINATION_RECEIPT,
]);

export const getIsMobilePosViewport = () => {
  if (typeof window === 'undefined') return false;
  if (typeof window.matchMedia === 'function') {
    return window.matchMedia(POS_MOBILE_MEDIA_QUERY).matches;
  }
  return Number(window.innerWidth || 1024) < 768;
};

export const shouldDefaultToRegisterlessPosScope = ({
  registerlessProfile,
  storedRegisterless = false,
  storedRegisterId,
  storedSessionId,
  isMobileViewport = getIsMobilePosViewport(),
} = {}) => Boolean(
  isMobileViewport
  && registerlessProfile?.id
  && !storedRegisterless
  && !storedRegisterId
  && !storedSessionId
);

const normalizeRegisterlessPostSubmitDestinationValue = (value, fallback) => {
  const normalized = String(value || '').trim();
  return REGISTERLESS_POST_SUBMIT_DESTINATIONS.has(normalized) ? normalized : fallback;
};

export const normalizeRegisterlessPostSubmitDestination = (
  value,
  fallback = DEFAULT_REGISTERLESS_POST_SUBMIT_DESTINATION
) => {
  const source = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  const base = fallback && typeof fallback === 'object' && !Array.isArray(fallback)
    ? fallback
    : DEFAULT_REGISTERLESS_POST_SUBMIT_DESTINATION;
  return {
    mobile: normalizeRegisterlessPostSubmitDestinationValue(
      source.mobile,
      normalizeRegisterlessPostSubmitDestinationValue(
        base.mobile,
        DEFAULT_REGISTERLESS_POST_SUBMIT_DESTINATION.mobile
      )
    ),
    desktop: normalizeRegisterlessPostSubmitDestinationValue(
      source.desktop,
      normalizeRegisterlessPostSubmitDestinationValue(
        base.desktop,
        DEFAULT_REGISTERLESS_POST_SUBMIT_DESTINATION.desktop
      )
    ),
  };
};

export const getRegisterlessPostSubmitDeviceKey = (
  isMobileViewport = getIsMobilePosViewport()
) => (isMobileViewport ? 'mobile' : 'desktop');

export const resolveRegisterlessPostSubmitDestination = ({
  registerlessProfile,
  isMobileViewport = getIsMobilePosViewport(),
} = {}) => {
  const settings = normalizeRegisterlessPostSubmitDestination(
    registerlessProfile?.postSubmitDestination
  );
  return settings[getRegisterlessPostSubmitDeviceKey(isMobileViewport)];
};

export const resolveCurrentPosScope = ({
  registers = [],
  userId,
  storedRegisterId,
  storedSessionId,
}) => {
  const list = Array.isArray(registers) ? registers : [];
  const canUseSession = (session) =>
    session && String(session.openedBy) === String(userId);

  let selectedRegister = list.find(
    (register) => String(register.id) === String(storedRegisterId)
  );
  let session = selectedRegister?.activeSession || null;

  if (session && storedSessionId && String(session.id) !== String(storedSessionId)) {
    session = null;
  }
  if (session && !canUseSession(session)) {
    session = null;
  }

  if (!session) {
    const fallback = list.find((register) => canUseSession(register.activeSession));
    if (fallback) {
      selectedRegister = fallback;
      session = fallback.activeSession;
    }
  }

  if (!selectedRegister && session?.cashRegisterId != null) {
    selectedRegister = list.find(
      (register) => String(register.id) === String(session.cashRegisterId)
    );
  }

  return { selectedRegister: selectedRegister || null, session: session || null };
};
